import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router';
import { BradcamArea } from '../dumb/bradcam-area/BradcamArea';
import { ContactArea} from '../dumb/contact-area/ContactArea';
import { ProjectArea } from '../dumb/project-area/ProjectArea';
import { Footer } from '../dumb/footer/Footer';
import { TestForm } from '../dumb/test-form/TestForm';
import { ScriptContainer } from '../smart/script/ScriptContainer';
import { Loader } from './utils/loader/Loader';




type props = {}

export const Contact = (props: any) => {

    //Hooks
    const [isOnline, setIsOnline] = useState(false);
    const [title, setTtile] = useState("CONTATTI");

    useEffect(() =>

        setIsOnline(true), [setIsOnline]
    );

    if (isOnline === false) {

        return <Loader />
    }
    else {
        if (props.redirect) return <Redirect push to="/home" />;
        else {
            $('html, body').scrollTop(0)
            return <div id="homeless-container">
            {/**bradcam area */}
            <BradcamArea {...props} title={title} />
            {/**contact area */}
            <ContactArea {...props} title={title} />
            {/**project area component */}
            <ProjectArea clickhandler={props.clickhandler}/>
            {/**footer area component */}
            <Footer clickhandler={props.clickhandler}/>
            {/**test form component */}
            <TestForm />
            {/**public scripts loader */}
            <ScriptContainer {...props} count={props.count} />
        </div>
        }
    }
}